import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "https://api.johnlewis.com/basket-ui",
  socialProofApi:
    "https://api.johnlewis.com/product-badging/api/v1/social-proof-messaging",
};

export default config;
